const ExpenseCategoryIcon = () => (
    <svg
        width={105}
        height={105}
        viewBox="0 0 105 105"
        fill="none"
    >
        <rect
            x={36.0938}
            y={63.7639}
            width={32.3024}
            height={32.3024}
            rx={16.1512}
            fill="white"
        />
        <mask
            id="mask0_558_7632"
            style={{
                maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={105}
            height={105}
        >
            <path
                d="M102.856 102.857V1.63305H1.63281V102.857H102.856Z"
                fill="white"
                stroke="white"
                strokeWidth={3.26531}
            />
        </mask>
        <g mask="url(#mask0_558_7632)">
            <path
                d="M62.3676 67.3781C59.6368 65.1518 56.1505 63.8169 52.3523 63.8169C43.5921 63.8169 36.4907 70.9185 36.4907 79.6785C36.4907 88.4389 43.5921 95.5403 52.3523 95.5403C61.1125 95.5403 68.2139 88.4389 68.2139 79.6785C68.2139 77.2671 67.6759 74.9812 66.7131 72.9346"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M32.0154 69.6748C30.5284 72.692 29.6931 76.0879 29.6931 79.6791C29.6931 92.1935 39.838 102.339 52.3524 102.339C64.8671 102.339 75.0122 92.1935 75.0122 79.6791C75.0122 67.1646 64.8671 57.0196 52.3524 57.0196C45.9896 57.0196 40.239 59.6422 36.1231 63.8657"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M55.0628 73.3453C54.7388 73.0778 52.7467 71.7767 50.872 72.7002C48.6698 73.7855 48.6227 76.1906 49.8594 77.5843C50.688 78.5183 52.029 78.821 53.7857 79.4412C57.7173 80.8294 56.2641 86.703 52.2645 86.7295C50.7039 86.74 49.9741 86.3057 48.6033 85.41"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M52.3525 86.7284V89.0749"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M52.3525 70.2995V72.3625"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.5062 27.7239C28.5062 20.2748 22.4674 14.2362 15.0184 14.2362C7.56928 14.2362 1.53052 20.2748 1.53052 27.7239C1.53052 35.1729 7.56928 41.2117 15.0184 41.2117C22.4674 41.2117 28.5062 35.1729 28.5062 27.7239Z"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M83.1714 15.5795C78.8965 17.8419 75.9836 22.3352 75.9836 27.5086C75.9836 34.9578 82.0224 40.9963 89.4714 40.9963C96.9205 40.9963 102.959 34.9578 102.959 27.5086C102.959 20.2688 97.2552 14.3613 90.0961 14.035"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M65.8404 15.6398C65.8404 8.1908 59.8016 2.15204 52.3525 2.15204C44.9035 2.15204 38.8647 8.1908 38.8647 15.6398C38.8647 23.0889 44.9035 29.1277 52.3525 29.1277C59.8016 29.1277 65.8404 23.0889 65.8404 15.6398Z"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M59.7835 45.3142L53.1752 36.3054C52.7674 35.7497 51.9374 35.7497 51.5297 36.3054L44.9211 45.3142C44.6246 45.7185 44.9134 46.2885 45.4148 46.2885H49.4391V49.7015C49.4391 49.9721 49.5466 50.2317 49.7379 50.423C49.9293 50.6144 50.1888 50.7219 50.4595 50.7219H54.2454C54.516 50.7219 54.7756 50.6144 54.9669 50.423C55.1583 50.2317 55.2658 49.9721 55.2658 49.7015V46.2885H59.2899C59.7915 46.2885 60.0803 45.7185 59.7835 45.3142Z"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M78.3062 55.7735L78.0601 44.6037C78.0447 43.9145 77.3647 43.4384 76.7119 43.6598L66.1315 47.2488C65.6566 47.4098 65.5662 48.0425 65.977 48.33L69.2733 50.6382L67.3158 53.4339C67.2389 53.5437 67.1844 53.6675 67.1554 53.7983C67.1264 53.9292 67.1235 54.0644 67.1467 54.1964C67.17 54.3284 67.219 54.4545 67.2911 54.5675C67.3631 54.6805 67.4566 54.7783 67.5664 54.8551L70.6676 57.0265C70.7774 57.1034 70.9012 57.1579 71.032 57.187C71.1629 57.216 71.2981 57.2189 71.4301 57.1957C71.5621 57.1724 71.6882 57.1234 71.8012 57.0514C71.9142 56.9794 72.012 56.8859 72.0888 56.7761L74.0464 53.9802L77.3429 56.2884C77.7537 56.5761 78.3172 56.2749 78.3062 55.7735Z"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M38.5628 47.2488L27.9822 43.6598C27.3295 43.4384 26.6495 43.9145 26.6342 44.6037L26.3881 55.7734C26.3771 56.2751 26.9405 56.5763 27.3512 56.2885L30.6479 53.9804L32.6054 56.7761C32.7606 56.9977 32.9976 57.1487 33.264 57.1957C33.5305 57.2427 33.8048 57.1819 34.0264 57.0267L37.1279 54.8551C37.3495 54.6998 37.5004 54.4629 37.5473 54.1964C37.5943 53.9299 37.5335 53.6557 37.3783 53.4341L35.4207 50.6384L38.7172 48.3302C39.1281 48.0424 39.0377 47.41 38.5628 47.2488Z"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.651 27.7245C21.651 24.0615 18.6814 21.0919 15.0184 21.0919C11.3553 21.0919 8.38574 24.0615 8.38574 27.7245C8.38574 31.3876 11.3553 34.3572 15.0184 34.3572C18.6814 34.3572 21.651 31.3876 21.651 27.7245Z"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M48.1851 20.7991C49.364 21.754 50.8357 22.274 52.3528 22.2717C56.0158 22.2717 58.9854 19.3023 58.9854 15.6391C58.9854 11.976 56.0158 9.00645 52.3528 9.00645C49.1485 9.00645 46.4747 11.2791 45.8555 14.3003"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M96.1041 27.5077C96.1041 23.8447 93.1346 20.8751 89.4715 20.8751C85.8085 20.8751 82.8389 23.8447 82.8389 27.5077C82.8389 31.1708 85.8085 34.1404 89.4715 34.1404C93.1346 34.1404 96.1041 31.1708 96.1041 27.5077Z"
                stroke="blue"
                strokeWidth={3.26531}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);
export default ExpenseCategoryIcon;
